import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { CardBackgroundComponent } from '../../card-background.component';
import { TheWoodsPostCardBackgroundViewModel } from './the-woods-post-card-background-view-model';
import type { TheWoodsCardData } from '../../../../../../../models/print-cards/the-woods-card-data';

@Component({
  selector: 'app-the-woods-post-card-background',
  templateUrl: './the-woods-post-card-background.component.html',
  styleUrl: './the-woods-post-card-background.component.scss',
  providers: [TheWoodsPostCardBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TheWoodsPostCardBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public viewModel: TheWoodsPostCardBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: TheWoodsCardData;
}
